module.exports = __webpack_public_path__ + "static/media/stijn-bessem-case-next-project-1440x400-inact.7fe6b7a5.jpg";